var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackwardicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "#3E3232",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 26C21.7188 26 21.4688 25.9062 21.2812 25.7188L16.2812 20.7188C15.875 20.3438 15.875 19.6875 16.2812 19.3125L21.2812 14.3125C21.6562 13.9062 22.3125 13.9062 22.6875 14.3125C23.0938 14.6875 23.0938 15.3438 22.6875 15.7188L18.4062 20L22.6875 24.3125C23.0938 24.6875 23.0938 25.3438 22.6875 25.7188C22.5 25.9062 22.25 26 22 26Z",
    fill: "#3E3232",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackwardicon);
export default __webpack_public_path__ + "static/media/backwardicon.714082d634947110a8073e4cc3ced50b.svg";
export { ForwardRef as ReactComponent };